import { put, call } from 'redux-saga/effects';
import * as actions from 'actions/vessels/size';
import mockSize from 'mocks/vessel/size.json';
import * as actionTypes from 'constants/ActionTypes';

function* fillAndCreateVesselSizes(clarified) {
    const items = [];
    clarified.forEach((item) => {
        if(item.warnings && item.warnings.length) return;
        items.push({
            ...mockSize,
            vesselName: item.mv.name,
            vessel: item.mv._id,
            imoNumber: item.mv.imoNumber,
            DWT: item.mv.dw ? item.mv.dw.summer : null,
            BLT: item.mv.blt,
        });
    });
    
    return items.length ? items : [mockSize];
}

export function* createVesselSizes(response) {
    if (response.status === 200) {
        if (response.data.clarified && response.data.clarified.length > 0) {
            const vesselSizes = yield call(fillAndCreateVesselSizes, response.data.clarified);
            yield put({
                type: actionTypes.ADD_NOTIFICATION,
                notification: {
                    title: 'Created',
                    message: `The ${vesselSizes.length} vessel sizes created`,
                    level: 'success',
                    _id: new Date().getMilliseconds(),
                    autoDismiss: 4,
                },
            });

            yield put(actions.createVesselSizes(vesselSizes));
        } else {
            yield put({
                type: actionTypes.ADD_NOTIFICATION,
                notification: {
                    title: 'Warning',
                    message: 'The vessel sizes were not created',
                    level: 'warning',
                    _id: new Date().getMilliseconds(),
                    autoDismiss: 4,
                },
            });
            yield put(actions.removeAllVesselSize());
            yield put(actions.addVesselSize());
        }
    } else {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Warning',
                message: 'The vessel sizes were not created',
                level: 'warning',
                _id: new Date().getMilliseconds(),
                autoDismiss: 4,
            },
        });

        yield put(actions.addVesselSize());
    }
}

export function* purposeRequired() {
    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Warning',
            message: 'Type By Purpose is required',
            level: 'warning',
            _id: new Date().getMilliseconds(),
            autoDismiss: 4,
        },
    });
}



// WEBPACK FOOTER //
// ./app/sagas/vessels/size.js